import { render } from "./LocationAccountingSettings.vue?vue&type=template&id=7353015c&scoped=true"
import script from "./LocationAccountingSettings.vue?vue&type=script&lang=js"
export * from "./LocationAccountingSettings.vue?vue&type=script&lang=js"

import "./LocationAccountingSettings.vue?vue&type=style&index=0&id=7353015c&scoped=true&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7353015c"]])

export default __exports__